exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".payment{margin-top:25px}.payment-form hr{border-color:#dce4ec}.reg-card-number{padding-top:3px}.reg-card-number__content{text-align:center;float:left}.reg-card-number__text{font-size:12px;margin:0}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader/lib/loader.js!./src/assets/styles/custom.scss
// module id = 191
// module chunks = 0